import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { App, AppCategory } from "../types";

type ZapierAppResponse = {
  results: App[];
};

export const appsByCategoryAtomFamily_SUSPENDS = atomFamily(
  (category?: AppCategory) => {
    const categoryAtom = atom(async () => {
      if (!category) {
        return [];
      }

      const url = `/api/canvasui/categories?category=${category}&limit=8`;
      const response = await fetch(url);

      if (!response.ok) {
        console.error(`Failed to fetch apps: ${response.statusText}`);
        return [];
      }

      const data: ZapierAppResponse = await response.json();
      return data.results;
    });
    categoryAtom.debugLabel = `appsByCategoryAsyncAtomFamily.ts(${category})`;
    return categoryAtom;
  },
);
